<template>
<div :class="[block.class, {'half-padding-top': block.half_padding_top}, {'half-padding-bottom': block.half_padding_bottom}]" :id="block.anchor ? block.anchor : ('block-' + block.id)">
    <h2 class="title">{{block.title}}</h2>
</div>
</template>

<script>
import BlockCommons from '../../mixins/BlockCommons';
export default {
    name        :   'Block',
    mixins      :   [ BlockCommons ],
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/modules/Block.vue